<div class="modal-dialog" role="document">
  <div class="modal-content bd-0">
    <div class="modal-header pd-y-20 pd-x-25">
      <h6 class="tx-14 mg-b-0 tx-uppercase tx-inverse tx-bold">{{ data.title }}</h6>
      <button type="button" class="btn-close" (click)="close(false)" aria-label="Close"></button>
    </div>
    <div class="modal-body p-5">
      <p class="mg-b-5" [innerHtml]="data.message"></p>
      <form [formGroup]="form">
        <div class="form-group mt-3">
          <label class="form-control-label">
            {{ data.emailLabel || ('SALES.ORDERS.DETAILS.DIALOG.PAYMENT-REQUEST.EMAIL.LABEL' | translate) }}
            <span class="tx-danger">*</span>
          </label>
          <input
            class="form-control"
            name="Email"
            formControlName="Email"
            placeholder="{{ 'SALES.ORDERS.DETAILS.DIALOG.PAYMENT-REQUEST.EMAIL.PLACEHOLDER' | translate }}"
            maxlength="255">
          <t4-display-validation controlName="Email" [form]="form" [messages]="validationMessages"></t4-display-validation>
        </div>
      </form>
    </div>

    <div class="modal-footer">
      <div class="col-6">
        <button type="button" class="btn btn-block btn-primary" (click)="close(true)">{{ okBtnText | translate }}</button>
      </div>
      <div class="col-6">
        <button type="button" class="btn btn-block btn-secondary" (click)="close(false)">{{ cancelBtnText | translate }}</button>
      </div>
    </div>
  </div>
</div>

